// Clima do dia no Diário (0.65): pela localização do celular, no serviço público Open-Meteo (sem cadastro).
// Sem permissão de localização (ou sem internet), o clima fica para preencher à mão.
import { Platform } from 'react-native';
import { N_, t } from './i18n';

const CODIGOS: [number[], string, string][] = [
  [[0], N_('céu limpo'), '☀️'], [[1, 2], N_('poucas nuvens'), '🌤️'], [[3], N_('nublado'), '☁️'], [[45, 48], N_('neblina'), '🌫️'],
  [[51, 53, 55, 56, 57], N_('garoa'), '🌦️'], [[61, 63, 65, 66, 67, 80, 81, 82], N_('chuva'), '🌧️'], [[71, 73, 75, 77, 85, 86], N_('neve'), '❄️'],
  [[95, 96, 99], N_('tempestade'), '⛈️'],
];
export const CONDICOES: [string, string][] = CODIGOS.map(([, n, e]) => [n, e]);
export const sensacao = (c: number) => (c < 12 ? N_('frio') : c < 18 ? N_('fresco') : c < 27 ? N_('agradável') : N_('calor'));
export const emojiCond = (cond?: string) => CODIGOS.find(([, n]) => cond?.includes(n))?.[2] ?? '🌡️';

/** "14 °C, frio, chuva" */
export function textoClima(c?: { temp?: number | null; cond?: string } | null) {
  if (!c) return '';
  return [c.temp != null ? `${Math.round(c.temp)} °C` : '', c.temp != null ? t(sensacao(c.temp)) : '', c.cond ? t(c.cond) : ''].filter(Boolean).join(', ');
}

async function posicao(): Promise<{ lat: number; lon: number } | null> {
  if (Platform.OS === 'web') {
    return new Promise(res => {
      if (!navigator?.geolocation) return res(null);
      navigator.geolocation.getCurrentPosition(p => res({ lat: p.coords.latitude, lon: p.coords.longitude }), () => res(null), { timeout: 8000, maximumAge: 3600000 });
    });
  }
  try {
    const L = require('expo-location');
    const p = await L.requestForegroundPermissionsAsync();
    if (!p.granted) return null;
    const ult = await L.getLastKnownPositionAsync({ maxAge: 3 * 3600000 });
    const pos = ult ?? await L.getCurrentPositionAsync({ accuracy: L.Accuracy?.Low ?? 2 });
    return pos ? { lat: pos.coords.latitude, lon: pos.coords.longitude } : null;
  } catch { return null; }
}

/** Clima agora no lugar onde o celular está, ou null. */
export async function climaAgora(): Promise<{ temp: number; cond: string } | null> {
  const p = await posicao();
  if (!p) return null;
  try {
    const url = `https://api.open-meteo.com/v1/forecast?latitude=${p.lat.toFixed(2)}&longitude=${p.lon.toFixed(2)}&current=temperature_2m,weather_code&timezone=auto`;
    const r = await fetch(url);
    if (!r.ok) return null;
    const j = await r.json();
    const temp = Number(j?.current?.temperature_2m);
    const cod = Number(j?.current?.weather_code);
    if (!isFinite(temp)) return null;
    return { temp, cond: CODIGOS.find(([cs]) => cs.includes(cod))?.[1] ?? '' };
  } catch { return null; }
}
